module.exports = __webpack_public_path__ + "static/media/David Milam.bc806e4a.png";